module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "pl-4 pr-4 pt-4 pb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "text-lg-left noMargin"
  }, [_c('strong', [_vm._v("Manufacturer Users")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "text-lg-left noMargin"
  }, [_c('strong', [_vm._v("Customer Users")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg5": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Alias")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Alias",
      "solo": ""
    },
    model: {
      value: (_vm.objUserSettings.manufacturerAlias),
      callback: function($$v) {
        _vm.$set(_vm.objUserSettings, "manufacturerAlias", $$v)
      },
      expression: "objUserSettings.manufacturerAlias"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v(" ")]), _vm._v(" "), _c('swatches', {
    attrs: {
      "colors": "text-advanced",
      "popover-to": "right"
    },
    model: {
      value: (_vm.objUserSettings.manufacturerColor),
      callback: function($$v) {
        _vm.$set(_vm.objUserSettings, "manufacturerColor", $$v)
      },
      expression: "objUserSettings.manufacturerColor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg5": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Alias")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Alias",
      "solo": ""
    },
    model: {
      value: (_vm.objUserSettings.customerAlias),
      callback: function($$v) {
        _vm.$set(_vm.objUserSettings, "customerAlias", $$v)
      },
      expression: "objUserSettings.customerAlias"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v(" ")]), _vm._v(" "), _c('swatches', {
    attrs: {
      "colors": "text-advanced",
      "popover-to": "right"
    },
    model: {
      value: (_vm.objUserSettings.customerColor),
      callback: function($$v) {
        _vm.$set(_vm.objUserSettings, "customerColor", $$v)
      },
      expression: "objUserSettings.customerColor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "text-lg-left noMargin"
  }, [_c('strong', [_vm._v("Specific Users")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "text-lg-left noMargin"
  }, [_c('strong', [_vm._v("Public Users")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg5": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Alias")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Alias",
      "solo": ""
    },
    model: {
      value: (_vm.objUserSettings.specificAlias),
      callback: function($$v) {
        _vm.$set(_vm.objUserSettings, "specificAlias", $$v)
      },
      expression: "objUserSettings.specificAlias"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v(" ")]), _vm._v(" "), _c('swatches', {
    attrs: {
      "colors": "text-advanced",
      "popover-to": "right"
    },
    model: {
      value: (_vm.objUserSettings.specificColor),
      callback: function($$v) {
        _vm.$set(_vm.objUserSettings, "specificColor", $$v)
      },
      expression: "objUserSettings.specificColor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg5": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Alias")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Alias",
      "solo": ""
    },
    model: {
      value: (_vm.objUserSettings.publicAlias),
      callback: function($$v) {
        _vm.$set(_vm.objUserSettings, "publicAlias", $$v)
      },
      expression: "objUserSettings.publicAlias"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v(" ")]), _vm._v(" "), _c('swatches', {
    attrs: {
      "colors": "text-advanced",
      "popover-to": "right"
    },
    model: {
      value: (_vm.objUserSettings.publicColor),
      callback: function($$v) {
        _vm.$set(_vm.objUserSettings, "publicColor", $$v)
      },
      expression: "objUserSettings.publicColor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncEditSettings()
      }
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1)
},staticRenderFns: []}